import { SET_LOCALE } from 'nucleus-widgets/redux/modules/text';

export const LOAD_LOCALIZED_USER_TEXT =
  'nucleus-guestside-site/localizedUserText/LOAD_LOCALIZED_USER_TEXT';

export function loadLocalizedUserText(locale, localizedUserText) {
  return {
    type: LOAD_LOCALIZED_USER_TEXT,
    payload: {
      locale,
      localizedUserText
    }
  };
}

/**
 * The reducer for the localized user text.
 */
export default function reducer(
  state = {
    localizations: {}
  },
  action
) {
  switch (action.type) {
    case SET_LOCALE:
      return {
        ...state,
        currentLocale: action.payload.locale
      };
    case LOAD_LOCALIZED_USER_TEXT:
      return {
        ...state,
        localizations: {
          ...state.localizations,
          [action.payload.locale]: {
            ...state.localizations[action.payload.locale],
            ...action.payload.localizedUserText
          }
        }
      };
    default:
      return state;
  }
}
